// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--3zUhp";